<template>
    <div id="partSaleInvoiceView">
        <div class="loader" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Invoice Detail</div>
                    <div class="btn-groups text-right">
                        <button type="button" class="btn btn-secondary" v-on:click="print()" >
                            <i class="fp-export"> </i> Print
                        </button>
                        <button type="button" class="btn btn-secondary" v-on:click="downloadPdf()" >
                            <i class="fp-download"> </i> Download
                        </button>
                        <button type="button" class="btn btn-secondary" v-on:click="backBtn()" >
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content manual-invoice-preview">
                        <section class="bg-white">
                            <div class="invoice-view-table" id="print_content_manual">

                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import LoadingContent from "@/components/LoadingContent.vue";
import {commonMixins} from '../../mixins/commonMixins';
Vue.component("loading-content", LoadingContent);

export default {
    name: "ManualInvoiceTemplate",
    components: {
        appFooter: () => import('@/components/Footer')
    },
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: "Customer Invoice Preview | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins],
    data: () => ({
        invoiceArr:[],
        loading:false,
        permissions:[],
        cantAccessPage:"",
        invoiceId : 0,
        path:"",
        invoice_number:'',
        invoice_date:'',
        due_date:'',
        customer:'',
        terms:'',
        po_no:'',
        invoice_type:'',
        sub_total:'',
        tax_amount:'',
        total:'',
        invoiceItemsArr:[],
        cust_code:'',
        cust_name:'',

    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        self.invoiceId = this.$route.params.id;
        self.getPermissions();
        self.loadInvoiceData();
        self.path = process.env.API +  "/images/logo.png";
    },
    methods : {
        backBtn(){
            var self = this;
            self.$router.push("/invoice/list");
        },
        loadInvoiceData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/part-sale-invoice/preview",
                type: "GET",
                data: {
                    invoice_id:self.invoiceId,
                },
                crossDomain: true,
                headers: {
                    'Accept': 'application/json',
                    "Access-Control-Allow-Origin": '*',
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dataType: "json",
                success: function (data) {
                    setTimeout(function(){
                        self.loading = false ;
                        $("#print_content_manual").html("");
                        $("#print_content_manual").html(data.view);
                    },500);

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'part-sale-invoice-preview');
                }
            });
        },
        downloadPdf() {
            var self = this;
            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_type:"",
                    invoice_origin:"manual"
                },
                headers: {
                    'Accept': 'application/json',
                    "Access-Control-Allow-Origin": '*',
                    "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'download-part-sale-invoice');
                }
            });

        },
        print() {
            var self = this;
            self.loading = true;
            var content = document.getElementById('print_content_manual').innerHTML;
            var a = window.open(content, '_blank');
            a.document.write(content);
            a.document.close();
            self.loading = false;
            a.print();
            a.close();
        }

    }
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/PartSaleInvoiceTemplate.vue